import { reduxStoreConfig } from "../../site/configuration/reduxStoreConfig";
import { useReduxState } from "../redux/hooks";
import { AppInfo } from "../types/System/AppInfo";


export const useAppInfo: () => [
  appInfo: AppInfo,
  setAppInfo: (appInfo: AppInfo) => void
] = () => {
  const [appInfo, setAppInfo] = useReduxState<AppInfo>(
    reduxStoreConfig.systemAppInfo
  );
  return [appInfo, setAppInfo];
};
